import { useCampaignStatus } from '../data/campaignStatus/useCampaignStatus';
import { useCampaignInfoItems } from './useCampaignInfoItems';
import { useCampaignInfoStyles } from './useCampaignInfoStyles';

export const useCampaignInfoDisplay = (campaignId?: string) => {
  const { isActiveSlot, campaign, isFinished, staticTiming } = useCampaignStatus(campaignId);

  const { getSelectedInfoItems } = useCampaignInfoItems({
    staticTiming,
    isActiveSlot,
    campaign
  });

  const {
    getCampaignInfoStyles,
    getColonForItem,
    shouldApplyCollapsedAttribute,
    getWrapperClassName,
    getDataAttributesByInfoType
  } = useCampaignInfoStyles({
    isActiveSlot,
    campaign
  });

  return {
    getCampaignInfoStyles,
    getSelectedInfoItems,
    getColonForItem,
    shouldApplyCollapsedAttribute,
    getWrapperClassName,
    getDataAttributesByInfoType,
    isFinished,
  };
};
